var $ = window.jQuery
var config = require('./common/config')

$(function() {

  loadList();
  // 新闻资讯列表 请求
  function loadList(num,minId) {
    $.ajax({
      url: config.newsURI  + '/main/WebService.asmx/getnewstitles',
      type: 'POST',
      data: {
        page: num || 0,
        rows: 12,
        rowminId: minId || 12
      },
      dataType: 'xml',
      success: function(result) {
        // 嗅探
        var browserName = navigator.userAgent.toLowerCase();
        if(/msie/i.test(browserName) && !/opera/.test(browserName)){
          // IE浏览器获取数据方法
          var data = JSON.parse($(result).find('string').text());
        }else {
          // 现代浏览器获取数据方法
          var data = JSON.parse($(result).find('string').html());
        }
        $('.news-content ul').empty();
        for(var i = 0 ; i<data.data.length; i++ ) {
            var list = data.data[i];
            $('.news-content ul').append('<li data-id="' + list.id + '"><a href="/main/arena/app/info-detail.html?page=' + list.id + '" target="_blank"><span>' + changeTime(list.Createtime) + '</span><span>' + list.title + '</span></a></li>')
        }

        // 设置新闻资讯列表页面数量
        $('#totalNewsPage').html(Math.ceil(data.total/12))
        // 如果新闻列表少于12条， 下一页颜色为灰色
        if (Math.ceil(data.total/12) == 1) {
          $('.info-content .btn .next').css('color', '#DFDFDF')
        }
        // 点击相对应的资讯页面 存储id值
        // $('.news-content ul li').each(function(i) {
        //   $('.news-content ul li').eq(i).click(function() {
        //     localStorage.setItem("id", $('.news-content ul li').eq(i).attr('data-id'));
        //   })
        // })
      },
      error: function(result) {
        console.log("获取新闻资讯错误！");
      }
    })
  }

  // 新闻资讯分页的上一页和下一页
  $('.info-content .btn .prev').on('click', function() {
    topNewsClick()
  })
  $('.info-content .btn .next').on('click', function() {
    downNewsClick()
  })
  // 分页函数 上一页
  function topNewsClick() {
    var num = $('#nowNewsPage').html();
    $('.info-content .btn .prev').prop('href','javascript:void(0)')
  	if(num > 1) {
  			num--;
        $('#nowNewsPage').html(num)
        var minId = $('.news-content ul li:last').attr('data-id')
        // 获取当前新闻列表的数量
        var count = $('.news-content ul li').length
        loadList(num,(parseInt(minId) + count + 12 ).toString());
        $('.info-content .btn .next').css('color', '#9B9B9B')
        $('.info-content .btn .prev').prop('href','#newsInformation')
        if(num == 1) {
          $('.info-content .btn .prev').css('color', '#DFDFDF')
        }
  	}
  }
  // 分页函数 下一页
  function downNewsClick() {
    var pages = parseInt($("#totalNewsPage").html());//获取当前的总页数
    var num = parseInt($("#nowNewsPage").html());
    $('.info-content .btn .next').prop('href','javascript:void(0)')
  	if(num < pages) {
  		num = ++num;
  	  $("#nowNewsPage").html(num);
      var minId = $('.news-content ul li:last').attr('data-id')
      loadList(num,minId);
      $('.info-content .btn .prev').css('color', '#9B9B9B')
      $('.info-content .btn .next').prop('href','#newsInformation')
      if(num == pages) {
        $('.info-content .btn .next').css('color', '#DFDFDF')
      }
  	}
  }

  // 视频播放方法
  var myPlayer = {};
  function videostart(obj,url) {
   var oBox = $("#videoContainer");
   oBox.css('display','block');
   var str = '<div class="video-box-close"><div class="before"></div><div class="after"></div></div>'+
             '<video id='+ obj +' class="video-js" controls preload="none">'+
             '<source class="source" src="/main/arena/video/'+ url +'.mp4" type="video/mp4">'+
             '</video>'
    $("#videoContainer").append(str);
      myPlayer = videojs(obj, {
       }, function() {
         this.play(); // if you don't trust autoplay for some reason
         // How about an event listener?
         this.on('ended',function(){
           $("#videoContainer").html('').css('display','none');
           $(".screem-mask").css('display','none');
           this.pause();
           this.hide()
         })
       });
     $(".screem-mask").css('display','block');
     var iWidth = $(document.body).width();
     var oWidth = $(document.body).css('overflow-y','hidden').width();
     var hl = oWidth - iWidth;
     $(document.body).css('margin-right', hl);
     parseInt(oBox.width()/1.5) <350 ? oBox.height( 350 ) : oBox.height( parseInt(oBox.width()/1.5) );
     oBox.find('.source').attr('src', './video/'+ url +'.mp4');
    }
  function closevideo() {
     myPlayer.dispose();
     $(document.body).css('margin-right', 0);
     $(document.body).css('overflow-y','auto');
     $("#videoContainer").html('').css('display','none');
     $(".screem-mask").css('display','none');
  }

  // 十一个视频 播放 each遍历
  $('.video-content ul li').each(function(i) {
    $('.video-content ul li:eq('+ i +') div').on('click',function() {
      // 点击 敬请期待 return
      if (i == 10) {
        return false
      }
      videostart('myVideo'+ (i+1) +'','video-00'+ (i+1) +'')
      $('#myVideo'+ (i+1) +'').css('width','100%').css('height','100%');
      $('.video-box-close').click(function() {
        closevideo()
      })
      $('.screem-mask').click(function() {
        closevideo()
      })
    })
  })

  // 视频分页的上一页和下一页
  $('.video-content .btn .prev').on('click', function() {
    topClick()
  })
  $('.video-content .btn .next').on('click', function() {
    downClick()
  })
  // 分页函数 上一页
  function topClick() {
    var num = $('#nowPage').html();
  	if(num > 0) {
  			num--;
        $('#nowPage').html(num)
        $('.video-content ul').css('margin-left', num*(-980) + 'px')
        $('.video-content .btn .next').css('color', '#9B9B9B')
        if(num == 0) {
          $('.video-content .btn .prev').css('color', '#DFDFDF')
        }
  	}
  }
  // 分页函数 下一页
  function downClick() {
    var pages = parseInt($("#totalPage").html());//获取当前的总页数
  	var num = parseInt($("#nowPage").html());
  	if(num < pages) {
  		num = ++num;
  	  $("#nowPage").html(num);
      $('.video-content ul').css('margin-left', num*(-980) + 'px')
      $('.video-content .btn .prev').css('color', '#9B9B9B')
      if(num == pages) {
        $('.video-content .btn .next').css('color', '#DFDFDF')
      }
  	}
  }

  // 日期转换
  function changeTime(result) {
    var date = new Date(result);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if(month<10) {
      month = "0" + month
    }
    if(day<10) {
      day = "0" + day
    }
    result = year + '-' + month + '-' + day;
    return result;
  }
})
